import(/* webpackMode: "eager" */ "/workspace/apps/frontend/src/app/page.tsx");
